import React from "react";
import { Box, Typography } from "@material-ui/core";

type Props = {
  fixed?: boolean;
  spacing?: number;
  title: string;
};

export const Header: React.FC<Props> = (props) => {
  return (
    <Box display="flex" alignItems="center">
      <Typography
        variant="subtitle1"
        component={Box}
        flexGrow={props.fixed ? 1 : 0}
        pr={props.children ? (props.spacing || 2) / 2 : 0}
      >
        <Box lineHeight="36px">{props.title}</Box>
      </Typography>
      {props.children ? (
        <Box flexGrow={props.fixed ? 1 : 0} pl={(props.spacing || 2) / 2}>
          {props.children}
        </Box>
      ) : null}
    </Box>
  );
};
